import styles from './EditGenericShapeMenu.module.scss'
import { TrashIcon } from '@phosphor-icons/react'
import { deleteShape } from '../../../store/actions'
import { useDispatch } from 'react-redux'
import { ReorderPicker } from '../components/ReorderPicker/ReorderPicker'
import { ScoopButton, ScoopTooltip } from '../../ui'
import { useModal, MODALS } from '../../modals'

export const EditGenericShapeMenu = ({ shape, handleDelete }) => {
    const dispatch = useDispatch()
    const deleteModal = useModal(MODALS.COMMON.DELETE)

    const handleDeleteShape = () => {
        handleDelete()
        dispatch(deleteShape(shape.id))
    }

    return (
        <div className={styles.menuContainer} id={'shape-menu'}>
            <ScoopTooltip title={'Delete'}>
                <ScoopButton
                    variant="text"
                    size="sm"
                    onClick={() =>
                        deleteModal.show({
                            title: 'Shape',
                            type: 'shape',
                            onDelete: handleDeleteShape,
                        })
                    }
                    className={styles.deleteButton}
                >
                    <TrashIcon size={20} weight="regular" />
                </ScoopButton>
            </ScoopTooltip>
            <ReorderPicker objectId={shape.id} origin={'top'} tooltip={'Reorder element'} />
        </div>
    )
}
